<div class="ui-g form-group" style="margin-bottom: 5px; width: 800px;"
    *ngIf="response.success!=null && response.success==true">

    <div class="card">

        <p-table #dt styleClass="ui-table-cars" id="doctors-grid" expandableRows="true" [responsive]="true">
            <ng-template pTemplate="caption" style="color: aliceblue;">
                <tr>
                    <td style="text-align: justify;">
                        <img [src]="profile.egd_users.avatar_url" height="120px" alt="Dr. Photo">
                        <h4>{{profile.salutation | titlecase}} {{profile.egd_users.first_name}}
                            {{profile.egd_users.last_name}},{{profile.degree}}
                        </h4>

                        <h4>{{profile.speciality.specialty_name}}, {{profile.egd_users.state_name}}, {{profile.egd_users.country.country_name}}</h4>


            </ng-template>

            <ng-template pTemplate="header" let-columns>

                <tr *ngIf="this.profile.secondary_speciality?.length>0">
                    <h4 class="display-4">Subspecialities </h4>
                    <ul *ngFor="let speciality of this.profile.secondary_speciality">
                        {{ speciality }}
                    </ul>
                </tr>

                <tr style="text-align: left;" *ngIf="langs.length>0">
                    <p class="header-section">Languages Spoken</p>
                    <ul>
                        <li style="white-space: pre-line;"
                            *ngFor="let l of langs">
                            {{l.language_name +" ("+l.english_name+")"}}
                        </li>
                    </ul>
                </tr>

                <tr style="text-align: justify;" *ngIf="profile.description?.length>0">
                    <h4 class="display-4">Bio</h4> {{profile.description}}
                </tr>

                <tr style="text-align: justify;" *ngIf="profile.education?.medical_school?.length>0">
                    <h4 class="display-4">Medical School </h4>
                    <ul>
                        <li *ngFor="let edu of profile.education?.medical_school">{{edu.name}} : {{edu.year}} </li>
                    </ul>
                </tr>

                <tr style="text-align: justify;" *ngIf="profile.education?.fellowship?.length>0">
                    <h4 class="display-4">Fellowship</h4>
                    <ul>
                        <li *ngFor="let edu of profile.education?.fellowship">{{edu.name}} : {{edu.year}} </li>
                    </ul>
                </tr>

                <tr style="text-align: left;"  *ngIf="profile.board_certification?.length>0">
                    <h4 class="display-4"> Board Certifications</h4>
                    <ul>
                        <li *ngFor="let board of profile.board_certification">{{board}}</li>
                    </ul>
                </tr>

                <tr style="text-align: left;" *ngIf="profile.honors_awards_recognition?.length>0">
                    <h4 class="display-4"> Honors, Awards & Recognitions</h4>
                    <ul>
                        <li *ngFor="let honors of profile.honors_awards_recognition">{{honors}}</li>
                    </ul>
                </tr>

                <tr style="text-align: left;" *ngIf="profile.publications?.length>0">
                    <h4 class="display-4"> Publications</h4>
                    <!-- <p style="text-align:justify;" *ngFor="let publication of profile.publications">
                        {{publication}}
                    </p> -->
                    <ul>
                        <li *ngFor="let publication of profile.publications">{{publication}}</li>
                    </ul>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching Doctor Profile...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6"></p-progressSpinner>
